import React, { useState } from 'react';
import apiClient from '../utils/api';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const btn = e.target.querySelector('#submit');
  const loader = btn.querySelector('.btn-loader');
  const formmessage = document.getElementById('formmessage');

  // Basic validation
  if (!formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
    formmessage.style.display = 'block';
    formmessage.className = 'form-notice error';
    formmessage.innerHTML = 'Please enter a valid email address';
    return;
  }

  if (!formData.phone.match(/^[+\d][\d\s-]+$/)) {
    formmessage.style.display = 'block';
    formmessage.className = 'form-notice error';
    formmessage.innerHTML = 'Please enter a valid phone number';
    return;
  }

  // Show loader
  loader.style.display = 'inline-block';
  formmessage.style.display = 'none';

  try {
    const response = await apiClient.post('contact', {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      message: formData.message.trim()
    });

    // Reset form
    setFormData({
      name: '',
      email: '',  
      phone: '',
      message: ''
    });

    // Show success message
    formmessage.style.display = 'block';
    formmessage.className = 'form-notice success';
    formmessage.innerHTML = 'Thank you for your message. We will contact you shortly.';

  } catch (error) {
    // Show error message
    formmessage.style.display = 'block';
    formmessage.className = 'form-notice error';
    formmessage.innerHTML = error.response?.data?.message || 'Error submitting form. Please try again later.';
  } finally {
    // Hide loader
    loader.style.display = 'none';
    
    // Scroll to message
    formmessage.scrollIntoView({ behavior: 'smooth' });
  }
};

  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Contact Us</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-2 page-section-ptb white-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-12 justify-content-center">
              <div className="section-title">
                <span>We'd Love to Hear From You</span>
                <h2>LET'S GET IN TOUCH!</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 col-sm-12 mb-lg-0 mb-1">
              <div className="gray-form row">
                <div className="col-md-12">
                  <form className="form-horizontal" role="form" onSubmit={handleSubmit}>
                    <h5>We've parked thousands of vehicles for hundreds of guests.</h5>
                    <p>Got a question or need more details? Send us a message through our contact page. We'll get back to you as soon as possible — no delays, no missed replies.</p>
                    <div id="formmessage" className="form-notice" style={{display: 'none'}}>Success/Error Message Goes Here</div>
                    <div className="contact-form">
                      <div className="mb-3">
                        <input 
                          id="contactform_name" 
                          type="text" 
                          placeholder="Name*" 
                          className="form-control"  
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <input 
                          id="contactform_email" 
                          type="email" 
                          placeholder="Email*" 
                          className="form-control" 
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <input 
                          id="contactform_phone" 
                          type="text" 
                          placeholder="Phone*" 
                          className="form-control" 
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <textarea 
                          id="contactform_message" 
                          className="form-control input-message" 
                          placeholder="Comment*" 
                          rows="9" 
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          required
                        ></textarea>
                      </div>
                      <div className="d-grid">
                        <button id="submit" name="submit" type="submit" value="Send" className="button red btn-block">
                          Send your message 
                          <i className="fa fa-spinner fa-spin fa-fw btn-loader" style={{display: 'none'}}></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="feature-box-3 grey-border">
                <div className="icon">
                  <i className="fa fa-map-marker"></i>
                </div>
                <div className="content">
                  <h5>Address </h5>
                  <p>Office No. 102, Building 35, Zone 38, Qatar.</p>
                </div>
              </div>
              <div className="feature-box-3 grey-border">
                <div className="icon">
                  <i className="fa fa-phone"></i>
                </div>
                <div className="content">
                  <h5>Phone </h5>
                  <p>+974 3377 7441</p>
                </div>
              </div>
              <div className="feature-box-3 grey-border mb-0">
                <div className="icon">
                  <i className="fa fa-envelope"></i>
                </div>
                <div className="content">
                  <h5>Email  </h5>
                  <p>info@valetparking.qa</p>
                </div>
              </div>
              <div className="opening-hours gray-bg">
                <h6>opening hours</h6>
                <ul className="list-style-none">
                  <li><strong>Sunday</strong> <span> 8:00 to 17:00</span></li>
                  <li><strong>Monday</strong> <span> 8:00 to 17:00</span></li>
                  <li><strong>Tuesday </strong> <span> 8:00 to 17:00</span></li>
                  <li><strong>Wednesday </strong> <span> 8:00 to 17:00</span></li>
                  <li><strong>Thursday </strong> <span> 8:00 to 17:00</span></li>
                  <li><strong>Friday</strong> <span className="text-red"> Closed</span></li>
                  <li><strong>Saturday </strong> <span> 8:00 to 17:00</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map">
        <div className="container-fluid">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.8697093611963!2d51.5163521!3d25.274967999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e45db5938526e31%3A0x90cb09e892ba7303!2sDigital%20Forge%20Marketing%20Agency!5e0!3m2!1sen!2sqa!4v1743964105802!5m2!1sen!2sqa" 
            title="Office Location"
            allowFullScreen
            style={{width: '100%', height: '450px', border: '0'}}
          ></iframe>
        </div>
      </section>
    </>
  );
}

export default Contact;
